import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import TrainingCardCarousel from "../../components/cards/trainingCards/trainingCardCarousel";
import { FilterMobileModal } from "../../components/dialogs/filterMobileModal";
import TrainingHeader from "../../components/headers/training";
import HeaderTrainingMobile from "../../components/headers/trainingMobile";
import PageLoader from "../../components/loader/loader";
import { netflixTrainingProgramViewed } from "../../components/mixPanelEvents/mixPanelEvents";
import Sidebar from "../../components/sidebar";
import SubNavigation from "../../components/subNavigation";
import { useCourses } from "../../hooks/useCourses";
import useHighlightCurrentMenuItem from "../../hooks/useHighlightCurrentMenuItem";
import SurveyModal from "../../components/dialogs/surveyModal/surveyModal";
import useSurveyAnswered from "../../hooks/useSurveyAnswered";
import { shouldShowWelcomeSurveyOld } from "../../helpers/utils";
import { axiosRequest } from "../../helpers/axios";

declare global {
   interface Window {
      axiosRequest: any;
   }
}

window.axiosRequest = axiosRequest;

function CourseCatalog() {
  const [
    filterData,
    loaded,
    courses,
    handleFilterTypeCheckboxChange,
    handleFilterCheckboxChange,
    selectedFilters,
    handleResetFilter,
    handleMobileFilterChange,
    popularCourses,
    recomendedCourses,
    handleFilterCheckboxChangeOnMobile,
  ] = useCourses();

  const { isSurveyAnswered: isWelcomeSurveyAnswered } = useSurveyAnswered('welcome');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));

  useHighlightCurrentMenuItem('/courses')

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offsetWidth, setOffsetWidth] = useState<number>(0);




  const updateContainerWidth = () => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  };
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        updateContainerWidth(); // Call the function to update container width
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
      updateContainerWidth(); // Call the function to update container width initially
    }

    return () => {
      observer.disconnect();
    };
  }, [containerRef.current]);

  useEffect(() => {
    console.log("Offset width changed:", offsetWidth); // Log offsetWidth changes
    // Trigger the useEffect whenever the offsetWidth changes
    setTimeout(() => {
      updateContainerWidth(); // Call the function to update container width
    }, 1000);
  }, [offsetWidth]);

  const handleSidebarToggle = () => {
    setSidebarOpen(!isSidebarOpen);
    setIsMobileFilterOpen(!isSidebarOpen);
  };

  const handleMobileFilterToggle = () => {
    setSidebarOpen((prev) => !prev)
    setIsMobileFilterOpen((prev) => !prev);
  };

  useEffect(() => {
    netflixTrainingProgramViewed();
  }, [])

  return (
    <>
      {!loaded && <PageLoader />}
      {isMobile && isMobileFilterOpen && (
        <FilterMobileModal
          handleMobileFilterChange={handleMobileFilterChange} // not used in the component
          handleResetFilter={handleResetFilter}
          onFilterChange={handleFilterCheckboxChangeOnMobile}
          onFilterTypeChange={handleFilterTypeCheckboxChange}
          selectedFilters={selectedFilters}
          filterData={filterData}
          handleMobileFilterToggle={handleMobileFilterToggle}
        />
      )}
      {loaded && filterData && (

        <Box
          id={"mainBox"}
          sx={{
            padding: isMobile ? "0 13px" : isSidebarOpen ? "0px" : "0 0",
            overflow: "hidden",
            margin: "0 auto",
            paddingTop: isMobile ? "40px" : "60px",
          }}
          className="maxWidthOverflow"
        >
          {isWelcomeSurveyAnswered === false && shouldShowWelcomeSurveyOld() && <SurveyModal />}
          {/* <SubNavigation /> */}
            <TrainingHeader
              onFilterChange={handleFilterCheckboxChange}
              selectedFilters={selectedFilters}
              handleSidebarToggle={handleSidebarToggle}
              isSidebarOpen={isSidebarOpen}
              filterData={filterData}
            />
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
            }}
            className="mainCoursesContainerMaster"
          >
            {!isMobile && (
              <Sidebar
                handleResetFilter={handleResetFilter}
                selectedFilters={selectedFilters}
                onFilterChange={handleFilterCheckboxChange}
                onFilterTypeChange={handleFilterTypeCheckboxChange}
                filterData={filterData}
                handleSidebarToggle={handleSidebarToggle}
                isSidebarOpen={isSidebarOpen}
              />
            )}

            <div
              className={isMobileFilterOpen ? "mobileFilterOpenedCorrection" : "mobileFilterClosedCorrection"}
            >
              {isMobile && (
                <HeaderTrainingMobile
                  selectedFilters={selectedFilters}
                  handleMobileFilterToggle={handleMobileFilterToggle}
                  filterData={filterData}
                  onFilterChange={handleFilterCheckboxChangeOnMobile}
                  handleResetFilter={handleResetFilter}
                  source="Training"
                />
              )}
              <Box
                ref={containerRef}
                style={{
                  width: "100%",
                  background: "#fff",
                  paddingTop: "0px",
                  overflow: "hidden",
                }}
                sx={{
                  height: isMobile && courses.length >= 5 ? "2260px" :
                    isMobile && courses.length >= 4 ? "1585px" :
                      isMobile && courses.length >= 3 ? "1385px" :
                        isMobile && courses.length >= 2 ? "1185px" :
                          isMobile ? "800px" : "auto",
                }}
                className={isSidebarOpen ? "mainCoursesContainer isSidebarOpen" : "mainCoursesContainer"}
              >
                {courses.map((course, index) => (
                  course.things.length > 0 && (
                    <div
                      key={index}
                      className={
                        course.things.length > 0
                          ? "carouselAndTitleAndArrowsContainer"
                          : ""
                      }
                    >
                      {course.things.length > 0 && (
                        <div className="coursesTrainingCarousel">

                          <TrainingCardCarousel
                            items={course.things}
                            width={containerWidth}
                            carouselTitle={course.name}
                            parentPage={"course"}
                            isSidebarOpen={isSidebarOpen}
                            locationValue="Courses"
                          />
                        </div>
                      )}
                    </div>)
                ))}
              </Box>
            </div>
          </Box>
        </Box>
      )}
    </>
  );
}
export default CourseCatalog;
